import { Category } from "../../contracts/Category";
import {
  choiceComponentWithId,
  flattenRichText,
  paragraphsForParagraphCollectionComponentWithId,
  stringForRichTextComponentWithId,
  stringForSingleLineComponentWithId,
} from "../../mapper/api-mappers";
import { DataMapper } from "..";
import { FolderPage } from "~/use-cases/contracts/FolderPage";

export default function FetchFolderToFolder(data: any): FolderPage {
  const mapper = DataMapper();
  const firstSeoChunk = data.meta?.content?.chunks[0];

  const story = paragraphsForParagraphCollectionComponentWithId(
    data.components,
    "story",
  );

  const description = data.components.find(
    (c: any) => c.id === "description",
  )?.content;

  const dto: FolderPage = {
    name: data.name,
    path: data.path,
    title:
      stringForSingleLineComponentWithId(data.components, "title") ||
      data.name!,
    description: description,
    story:
      story?.map((paragraph) => {
        return {
          title: paragraph.title?.text || "",
          body: flattenRichText(paragraph.body),
          images: mapper.API.Object.APIImageToImage(paragraph.images),
        };
      }) || [],
    hero: data.hero?.content?.grid
      ? data.hero.content.grid.map((grid: any) => ({
          id: grid.id,
          rows: grid.rows,
        }))
      : [],
    seo: mapper.API.Object.APIMetaSEOComponentToSEO(firstSeoChunk),
  };

  return dto;
}
